import { createQueryKeys } from "@lukemorales/query-key-factory";
import type { QueryKey } from "@tanstack/react-query";

import type { Service } from "../service";

const USER = "user";
const CREATE = "create";
const UPDATE = "update";
const DELETE = "delete";
const ASSIGN_ROLES = "assignRoles";
const GET = "get";
const GET_ALL = "getAll";
const GET_PAGINATED = "getPaginated";

const MUTATION_KEYS = {
  [CREATE]: [USER, CREATE],
  [UPDATE]: [USER, UPDATE],
  [DELETE]: [USER, DELETE],
  [ASSIGN_ROLES]: [USER, ASSIGN_ROLES],
} as const satisfies Record<string, QueryKey>;

const QUERY_KEYS = createQueryKeys(USER, {
  [GET]: (params: Parameters<Service[typeof GET]>[0]) => [params],
  [GET_ALL]: null,
  [GET_PAGINATED]: (params: Parameters<Service[typeof GET_PAGINATED]>[0]) => [params],
});

export {
  ASSIGN_ROLES,
  CREATE,
  DELETE,
  GET,
  GET_ALL,
  GET_PAGINATED,
  MUTATION_KEYS,
  QUERY_KEYS,
  UPDATE,
};
